import makeLookupModal from "../../UI/LookupModal/LookupModal";
import AcademicCalendarLookup from "./AcademicCalendarLookup";
const AcademicCalendarLookupModal = makeLookupModal(AcademicCalendarLookup, {
    pluralEntityName: "Terms",
});
export default AcademicCalendarLookupModal;
